import { render } from "./ReturnGoods.vue?vue&type=template&id=1d624c02&scoped=true"
import script from "./ReturnGoods.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnGoods.vue?vue&type=script&setup=true&lang=js"

import "./ReturnGoods.vue?vue&type=style&index=0&id=1d624c02&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d624c02"],['__file',"src/pages/components/parts/ReturnGoods.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d624c02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d624c02', __exports__)) {
    console.log('reload')
    api.reload('1d624c02', __exports__)
  }
  
  module.hot.accept("./ReturnGoods.vue?vue&type=template&id=1d624c02&scoped=true", () => {
    console.log('re-render')
    api.rerender('1d624c02', render)
  })

}


export default __exports__